// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Ecuador from '../_raw/flag/icon_flag_ecuador.png';

export default () => <img src={Ecuador} alt="Ecuador" />;
